import React, { useEffect } from 'react';
import { Button, Form, Input, Modal, Tag, Space, Typography } from 'antd';
import { AdminTag } from '../../../types/tag.types';

interface TagFormModalProps {
  open: boolean;
  loading?: boolean;
  initialTag?: AdminTag | null;
  onCancel: () => void;
  onSubmit: (values: { name: string }) => Promise<void>;
}

export const TagStatusBadge: React.FC<{ status: 'ACTIVE' | 'INACTIVE' }> = ({ status }) => {
  if (status === 'ACTIVE') {
    return <Tag color="green">Ativa</Tag>;
  }

  return <Tag color="default">Inativa</Tag>;
};

export const TagRowActions: React.FC<{
  tag: AdminTag;
  onEdit: (tag: AdminTag) => void;
  onInactivate: (tag: AdminTag) => void;
  onReactivate: (tag: AdminTag) => void;
}> = ({ tag, onEdit, onInactivate, onReactivate }) => {
  return (
    <Space>
      <Button type="link" onClick={() => onEdit(tag)}>
        Editar
      </Button>
      {tag.status === 'ACTIVE' ? (
        <Button type="link" danger onClick={() => onInactivate(tag)}>
          Inativar
        </Button>
      ) : (
        <Button type="link" onClick={() => onReactivate(tag)}>
          Reativar
        </Button>
      )}
    </Space>
  );
};

export const TagFormModal: React.FC<TagFormModalProps> = ({
  open,
  loading,
  initialTag,
  onCancel,
  onSubmit,
}) => {
  const [form] = Form.useForm<{ name: string }>();

  useEffect(() => {
    if (!open) {
      return;
    }

    form.setFieldsValue({ name: initialTag?.name ?? '' });
  }, [open, initialTag, form]);

  return (
    <Modal
      open={open}
      title={initialTag ? 'Editar etiqueta' : 'Nova etiqueta'}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
    >
      <Typography.Paragraph type="secondary">
        Nomes sao unicos sem diferenca por caixa e acentuacao.
      </Typography.Paragraph>

      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
      >
        <Form.Item
          label="Nome da etiqueta"
          name="name"
          rules={[
            { required: true, message: 'Informe o nome da etiqueta' },
            { max: 80, message: 'Use no maximo 80 caracteres' },
          ]}
        >
          <Input placeholder="Ex.: Mobilidade" maxLength={80} />
        </Form.Item>

        <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button onClick={onCancel}>Cancelar</Button>
          <Button htmlType="submit" type="primary" loading={loading}>
            {initialTag ? 'Salvar alteracoes' : 'Criar etiqueta'}
          </Button>
        </Space>
      </Form>
    </Modal>
  );
};
